import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  bulkAtividadesCarro,
  getAtividadesCarro,
  GetAtividadesCarroParams,
  SubtarefasDaEsteiraPayload,
} from '../../../api/atividadeCarroApi';
import { queryKeys } from '../queryKeys';

export const useAtividadesCarroQuery = (params: GetAtividadesCarroParams, enabled = true) => {
  return useQuery({
    queryKey: queryKeys.atividadesCarro.list(params),
    queryFn: () => getAtividadesCarro(params),
    enabled,
    staleTime: 60_000,
  });
};

export const useBulkAtividadesCarroMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      carId,
      statuses,
      subtarefas,
    }: {
      carId: string;
      statuses: string[];
      // at-89: opcional — ausente preserva a seleção de sub-tarefas do veículo.
      subtarefas?: SubtarefasDaEsteiraPayload[];
    }) => bulkAtividadesCarro(carId, statuses, subtarefas),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.atividadesCarro.all });
      queryClient.invalidateQueries({
        queryKey: queryKeys.atividadesCarro.list({ carId: variables.carId, isActive: true }),
      });
    },
  });
};
